const nerves_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].RadioButtonList[3]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Does ##name## have any symptom of ##redHeading## attributable to any peripheral nerve conditions?",
      "redHeading":"Constant pain",
      "sub":"",
      "type":"radio",
      "show": true,
      "multi": true,
      "section": {
         page: "2",
         title: "SYMPTOMS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None1[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild1[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate1[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe1[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None2[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild2[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate2[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe2[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Right Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None3[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild3[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate3[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe3[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None4[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild4[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate4[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe4[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         }
      ]
   },
   {
      "question":"Does ##name## have any symptom of ##redHeading## attributable to any peripheral nerve conditions?",
      "redHeading":"Intermittent pain",
      "sub":"",
      "type":"radio",
      "show": true,
      "multi": true,
      "section": {
         page: "2",
         title: "SYMPTOMS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None5[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild5[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate5[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe5[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None6[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild6[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate6[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe6[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Right Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None7[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild7[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate7[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe7[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None8[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild8[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate8[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe8[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         }
      ]
   },
   {
      "question":"Does ##name## have any symptom of ##redHeading## attributable to any peripheral nerve conditions?",
      "redHeading":"Paresthesias and/or dysesthesias",
      "sub":"",
      "type":"radio",
      "show": true,
      "multi": true,
      "section": {
         page: "2",
         title: "SYMPTOMS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None9[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild9[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate9[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe9[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None10[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild10[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate10[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe10[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Right Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None11[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild11[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate11[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe11[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_2[0].None12[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_2[0].Mild12[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_2[0].Moderate12[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_2[0].Severe12[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         }
      ]
   },
   {
      "question":"Does ##name## have any symptom of ##redHeading## attributable to any peripheral nerve conditions?",
      "redHeading":"Numbness",
      "sub":"",
      "type":"radio",
      "show": true,
      "multi": true,
      "section": {
         page: "3",
         title: "SYMPTOMS",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_3[0].None13[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_3[0].Mild13[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_3[0].Moderate13[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_3[0].Severe13[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Upper Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_3[0].None14[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_3[0].Mild14[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_3[0].Moderate14[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_3[0].Severe14[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Right Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_3[0].None15[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_3[0].Mild15[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_3[0].Moderate15[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_3[0].Severe15[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         },
         {
            "label":"Left Lower Extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Moderate",
            "options":[
               {
                  "main":"None",
                  "dbqName":"F[0].Page_3[0].None16[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_3[0].Mild16[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_3[0].Moderate16[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_3[0].Severe16[0],F[0].Page_2[0].Yes2[0]",
                  "sub":""
               }
            ],
            "answer":"Moderate"
         }
      ]
   },

   {
      "question":"Rate Muscle Strength",
      "sub":"",
      "type":"select",
      "show": true,
      "section": {
         page: "3",
         title: "MUSCLE STRENGTH TESTING",
         number: "4A"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Elbow Flexion",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "5",
                  "dbqName":"F[0].Page_3[0].ElbowFlexionR_0[0],F[0].Page_3[0].ElbowFlexionR_1[0],F[0].Page_3[0].ElbowFlexionR_2[0],F[0].Page_3[0].ElbowFlexionR_3[0],F[0].Page_3[0].ElbowFlexionR_4[0],F[0].Page_3[0].ElbowFlexionR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                 "main":"Elbow Extension",
                 "sub":"",
                 "type":"check",
                "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].ElbowExtensionR_0[0],F[0].Page_3[0].ElbowExtensionR_1[0],F[0].Page_3[0].ElbowExtensionR_2[0],F[0].Page_3[0].ElbowExtensionR_3[0],F[0].Page_3[0].ElbowExtensionR_4[0],F[0].Page_3[0].ElbowExtensionR_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
               },
               {
                 "main":"Wrist Flexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].WristFlexionR_0[0],F[0].Page_3[0].WristFlexionR_1[0],F[0].Page_3[0].WristFlexionR_2[0],F[0].Page_3[0].WristFlexionR_3[0],F[0].Page_3[0].WristFlexionR_4[0],F[0].Page_3[0].WristFlexionR_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
               },
               {
                "main":"Wrist Extension",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].WristExtensionR_0[0],F[0].Page_3[0].WristExtensionR_1[0],F[0].Page_3[0].WristExtensionR_2[0],F[0].Page_3[0].WristExtensionR_3[0],F[0].Page_3[0].WristExtensionR_4[0],F[0].Page_3[0].WristExtensionR_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
               },
               {
                  "main":"Grip",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].GripR_0[0],F[0].Page_3[0].GripR_1[0],F[0].Page_3[0].GripR_2[0],F[0].Page_3[0].GripR_3[0],F[0].Page_3[0].GripR_4[0],F[0].Page_3[0].GripR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                 "main":"Pinch (thumb to index finger)",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].PinchR_0[0],F[0].Page_3[0].PinchR_1[0],F[0].Page_3[0].PinchR_2[0],F[0].Page_3[0].PinchR_3[0],F[0].Page_3[0].PinchR_4[0],F[0].Page_3[0].PinchR_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
               },
               {
                  "main":"Knee Extension",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":"F[0].Page_3[0].KneeR_0[0],F[0].Page_3[0].KneeR_1[0],F[0].Page_3[0].KneeR_2[0],F[0].Page_3[0].KneeR_3[0],F[0].Page_3[0].KneeR_4[0],F[0].Page_3[0].KneeR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Ankle Plantar Flexion",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":   "F[0].Page_3[0].PlantarR_0[0],F[0].Page_3[0].PlantarR_1[0],F[0].Page_3[0].PlantarR_2[0],F[0].Page_3[0].PlantarR_3[0],F[0].Page_3[0].PlantarR_4[0],F[0].Page_3[0].PlantarR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Ankle Dorsiflexion",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":   "F[0].Page_3[0].AnkleR_0[0],F[0].Page_3[0].AnkleR_1[0],F[0].Page_3[0].AnkleR_2[0],F[0].Page_3[0].AnkleR_3[0],F[0].Page_3[0].AnkleR_4[0],F[0].Page_3[0].AnkleR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
            ]
         },
         {
           "label":"Flexion/Extension",
           "title":"Left Side",
           "subMain":"Rate Strength",
           "sub":"",
           "options":[
              {
                 "main":"Elbow Flexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].ElbowFlexionL_0[0],F[0].Page_3[0].ElbowFlexionL_1[0],F[0].Page_3[0].ElbowFlexionL_2[0],F[0].Page_3[0].ElbowFlexionL_3[0],F[0].Page_3[0].ElbowFlexionL_4[0],F[0].Page_3[0].ElbowFlexionL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                "main":"Elbow Extension",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                "dbqName":  "F[0].Page_3[0].ElbowExtensionL_0[0],F[0].Page_3[0].ElbowExtensionL_1[0],F[0].Page_3[0].ElbowExtensionL_2[0],F[0].Page_3[0].ElbowExtensionL_3[0],F[0].Page_3[0].ElbowExtensionL_4[0],F[0].Page_3[0].ElbowExtensionL_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
              },
              {
                "main":"Wrist Flexion",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                "dbqName":  "F[0].Page_3[0].WristFlexionL_0[0],F[0].Page_3[0].WristFlexionL_1[0],F[0].Page_3[0].WristFlexionL_2[0],F[0].Page_3[0].WristFlexionL_3[0],F[0].Page_3[0].WristFlexionL_4[0],F[0].Page_3[0].WristFlexionL_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
              },
              {
               "main":"Wrist Extension",
               "sub":"",
               "type":"check",
                 "defaultVal": "5",
               "dbqName":   "F[0].Page_3[0].WristExtensionL_0[0],F[0].Page_3[0].WristExtensionL_1[0],F[0].Page_3[0].WristExtensionL_2[0],F[0].Page_3[0].WristExtensionL_3[0],F[0].Page_3[0].WristExtensionL_4[0],F[0].Page_3[0].WristExtensionL_5[0]",
               "values":[
                 "0",
                 "1",
                 "2",
                 "3",
                 "4",
                 "5"
               ],
               "answer":"5"
              },
              {
                 "main":"Grip",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].GripL_0[0],F[0].Page_3[0].GripL_1[0],F[0].Page_3[0].GripL_2[0],F[0].Page_3[0].GripL_3[0],F[0].Page_3[0].GripL_4[0],F[0].Page_3[0].GripL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                "main":"Pinch (thumb to index finger)",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                "dbqName":  "F[0].Page_3[0].PinchL_0[0],F[0].Page_3[0].PinchL_1[0],F[0].Page_3[0].PinchL_2[0],F[0].Page_3[0].PinchL_3[0],F[0].Page_3[0].PinchL_4[0],F[0].Page_3[0].PinchL_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
              },
              {
                 "main":"Knee Extension",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].KneeL_0[0],F[0].Page_3[0].KneeL_1[0],F[0].Page_3[0].KneeL_2[0],F[0].Page_3[0].KneeL_3[0],F[0].Page_3[0].KneeL_4[0],F[0].Page_3[0].KneeL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                 "main":"Ankle Plantar Flexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].PlantarL_0[0],F[0].Page_3[0].PlantarL_1[0],F[0].Page_3[0].PlantarL_2[0],F[0].Page_3[0].PlantarL_3[0],F[0].Page_3[0].PlantarL_4[0],F[0].Page_3[0].PlantarL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                 "main":"Ankle Dorsiflexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_3[0].AnkleL_0[0],F[0].Page_3[0].AnkleL_1[0],F[0].Page_3[0].AnkleL_2[0],F[0].Page_3[0].AnkleL_3[0],F[0].Page_3[0].AnkleL_4[0],F[0].Page_3[0].AnkleL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
           ]
        }
         
      ],
      "rules": [
        {
           "label":"Muscle Strength-Rate Scale",
           "legend":"muscleStrengthScale",
           "title":".",
           "subMain":"",
           "sub":"",
           "options":[
              {
                 "main":"No Muscle Movement",
                 "sub":"0/5"
              },
              {
                 "main":"Visible Muscle Contraction but No Joint Movement",
                 "sub":"1/5"
              },
              {
                 "main":"Active Movement with Gravity Eliminated",
                 "sub":"2/5"
              },
              {
                 "main":"Active Movement Against Gravity",
                 "sub":"3/5"
              },
              {
                 "main":"Active Movement Against Some Resistance",
                 "sub":"4/5"
              },
              {
                 "main":"Normal Strength",
                 "sub":"5/5"
              }
           ]
        }
      ]
   },

   {
      "question":"Reflex Exam",
      "sub":"",
      "type":"select",
      "show": true,
      "section": {
         page: "3",
         title: "REFLEX EXAM",
         number: "5"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Biceps",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_3[0].BicepsR_0[0],F[0].Page_3[0].BicepsR_1[0],F[0].Page_3[0].BicepsR_2[0],F[0].Page_3[0].BicepsR_3[0],F[0].Page_3[0].BicepsR_4[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               },
               {
                 "main":"Triceps",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "2+",
                 "dbqName":  "F[0].Page_3[0].TricepsR_0[0],F[0].Page_3[0].TricepsR_1[0],F[0].Page_3[0].TricepsR_2[0],F[0].Page_3[0].TricepsR_3[0],F[0].Page_3[0].TricepsR_4[0]",
                 "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                 "main":"Brachioradialis",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "2+",
                 "dbqName":  "F[0].Page_3[0].BrachR_0[0],F[0].Page_3[0].BrachR_1[0],F[0].Page_3[0].BrachR_2[0],F[0].Page_3[0].BrachR_3[0],F[0].Page_3[0].BrachR_4[0]",
                 "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                "main":"Knee",
                "sub":"",
                "type":"check",
                "defaultVal": "2+",
                 "dbqName":  "F[0].Page_3[0].KneeR_0p[0],F[0].Page_3[0].KneeR_1plus[0],F[0].Page_3[0].KneeR_2plus[0],F[0].Page_3[0].KneeR_3plus[0],F[0].Page_3[0].KneeR_4plus[0]",
                "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                  "main":"Ankle",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_3[0].AnkleR_0p[0],F[0].Page_3[0].AnkleR_1plus[0],F[0].Page_3[0].AnkleR_2plus[0],F[0].Page_3[0].AnkleR_3plus[0],F[0].Page_3[0].AnkleR_4plus[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               }
            ]
         },
         {
           "label":"Flexion/Extension",
           "title":"Left Side",
           "subMain":"Rate Strength",
           "sub":"",
           "options":[
               {
                  "main":"Biceps",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_3[0].BicepsL_0[0],F[0].Page_3[0].BicepsL_1[0],F[0].Page_3[0].BicepsL_2[0],F[0].Page_3[0].BicepsL_3[0],F[0].Page_3[0].BicepsL_4[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               },
               {
               "main":"Triceps",
               "sub":"",
               "type":"check",
               "defaultVal": "2+",
               "dbqName": "F[0].Page_3[0].TricepsL_0[0],F[0].Page_3[0].TricepsL_1[0],F[0].Page_3[0].TricepsL_2[0],F[0].Page_3[0].TricepsL_3[0],F[0].Page_3[0].TricepsL_4[0]",
               "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
               "main":"Brachioradialis",
               "sub":"",
               "type":"check",
               "defaultVal": "2+",
               "dbqName": "F[0].Page_3[0].BrachL_0[0],F[0].Page_3[0].BrachL_1[0],F[0].Page_3[0].BrachL_2[0],F[0].Page_3[0].BrachL_3[0],F[0].Page_3[0].BrachL_4[0]",
               "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
               "main":"Knee",
               "sub":"",
               "type":"check",
               "defaultVal": "2+",
               "dbqName": "F[0].Page_3[0].KneeL_0p[0],F[0].Page_3[0].KneeL_1plus[0],F[0].Page_3[0].KneeL_2plus[0],F[0].Page_3[0].KneeL_3plus[0],F[0].Page_3[0].KneeL_4plus[0]",
               "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                  "main":"Ankle",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_3[0].AnkleL_0p[0],F[0].Page_3[0].AnkleL_1plus[0],F[0].Page_3[0].AnkleL_2plus[0],F[0].Page_3[0].AnkleL_3plus[0],F[0].Page_3[0].AnkleL_4plus[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               }
           ]
        }
         
      ],
      "rules": [
         {
            "label":"Deep Tendon Reflex (DTR) Scale",
            "legend": "reflexExamScale",
            "options":[
               {
                  "main":"0",
                  "sub":"Absent"
               },
               {
                  "main":"1+",
                  "sub":"Hypoactive"
               },
               {
                  "main":"2+",
                  "sub":"Normal"
               },
               {
                  "main":"3+",
                  "sub":"Hyperactive without clonus"
               },
               {
                  "main":"4+",
                  "sub":"Hyperactive with clonus"
               }
            ]
         }
       ]
   },

   {
      "question":"Sensory Exam",
      "sub":"",
      "type":"select",
      "show": true,
      "section": {
         page: "3",
         title: "REFLEX EXAM",
         number: "6"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Shoulder Area",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_4[0].Normal1[0],F[0].Page_4[0].Decreased1[0],F[0].Page_4[0].Absent1[0]",
                  "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Inner/Outer Forearm",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_4[0].Normal3[0],F[0].Page_4[0].Decreased3[0],F[0].Page_4[0].Absent3[0]",
                 "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Hand/Fingers",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_4[0].Normal5[0],F[0].Page_4[0].Decreased5[0],F[0].Page_4[0].Absent5[0]",
                 "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                "main":"Upper Anterior Thigh",
                "sub":"",
                "type":"check",
                "defaultVal": "Normal",
                "dbqName":   "F[0].Page_4[0].Normal7[0],F[0].Page_4[0].Decreased7[0],F[0].Page_4[0].Absent7[0]",
                "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                  "main":"Knee/Thigh",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_4[0].Normal9[0],F[0].Page_4[0].Decreased9[0],F[0].Page_4[0].Absent9[0]",
                  "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Ankle/Lower Leg",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_4[0].Normal11[0],F[0].Page_4[0].Decreased11[0],F[0].Page_4[0].Absent11[0]",
                 "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                  "main":"Foot/Toes",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_4[0].Normal11a[0],F[0].Page_4[0].Decreased11a[0],F[0].Page_4[0].Absent11a[0]",
                  "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               }
            ]
         },
         {
           "label":"Flexion/Extension",
           "title":"Left Side",
           "subMain":"Rate Strength",
           "sub":"",
           "options":[
               {
                  "main":"Shoulder Area",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_4[0].Normal2[0],F[0].Page_4[0].Decreased2[0],F[0].Page_4[0].Absent2[0]",
                  "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
               "main":"Inner/Outer Forearm",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal",
               "dbqName":"F[0].Page_4[0].Normal4[0],F[0].Page_4[0].Decreased4[0],F[0].Page_4[0].Absent4[0]",
               "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
               "main":"Hand/Fingers",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal",
               "dbqName":"F[0].Page_4[0].Normal6[0],F[0].Page_4[0].Decreased6[0],F[0].Page_4[0].Absent6[0]",
               "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
               "main":"Upper Anterior Thigh",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal", 
               "dbqName":"F[0].Page_4[0].Normal8[0],F[0].Page_4[0].Decreased8[0],F[0].Page_4[0].Absent8[0]",
               "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                  "main":"Knee/Thigh",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_4[0].Normal10[0],F[0].Page_4[0].Decreased10[0],F[0].Page_4[0].Absent10[0]",
                  "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
               "main":"Ankle/Lower Leg",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal",
               "dbqName":  "F[0].Page_4[0].Normal12[0],F[0].Page_4[0].Decreased12[0],F[0].Page_4[0].Absent12[0]",
               "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                  "main":"Foot/Toes",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_4[0].Normal12a[0],F[0].Page_4[0].Decreased12a[0],F[0].Page_4[0].Absent12a[0]",
                  "values":[
                     "Decreased",
                     "Normal",
                     "Absent"
                  ],
                  "answer":"Normal"
               }
           ]
        }         
      ]
   },   

   {
      "question":"Does ##name## have trophic changes attributable to peripheral neuropathy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: " TROPHIC CHANGES",
         number: "7"
      },
      "presidence":"Yes",
      "maxLength":90,
      "ref":0,
      "dbqName_yes":"F[0].Page_4[0].Yes4a[0]",
      "dbqName_no":"F[0].Page_4[0].No4a[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe",
      "textdbqName":"F[0].Page_4[0].Describe[0]",
      "textanswer":""
   },

   {
      "question":"Is ##name##'s Gait Normal?",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "GAIT",
         number: "8"
      },
      "questions":[
         {
            "main":"Normal gait",
            "dbqName":"F[0].Page_4[0].Yes6[0]",
            "answer":"",
            // "textarea": true,
            // "maxLength":86,
            // "textdbqName" : "F[0].Page_4[0].Describe[2]",
            // "placeholder": "Provide etiology of abnormal gait",
            // "textAnswer": ""
         },
         {
            "main":"Abnormal gait",
            "dbqName":"F[0].Page_4[0].No6[0]",
            "answer":"",
            "textarea": true,
            "maxLength":86,
            "textdbqName" : "F[0].Page_4[0].Describe[3]",
            "placeholder": "Please describe abnormal gait",
            "textAnswer": ""
         },            
      ],
      "answer":""
   },

   {
      "question":"Where special tests indicated and performed for median nerve evaluation?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "SPECIAL TESTS FOR MEDIAN NERVE",
         number: "9"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_4[0].Yes4[0]",
      "dbqName_no":"F[0].Page_4[0].No4[0]",
      "answer":"",
   },
   {
      "question":"Please indicate results for median nerve evaluation",
      "sub":"",
      "type":"radio",
      "show": false,
      "multi": false,
      "refId":1,
      "section": {
         page: "4",
         title: "SPECIAL TESTS FOR MEDIAN NERVE",
         number: "9"
      },
      "questions":[
         {
            "label":"Right Phalen's sign",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"F[0].Page_4[0].Phalens[0]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"F[0].Page_4[0].Phalens[1]",
                  "sub":""
               }
            ],
            "answer":"Negative"
         },
         {
            "label":"Left Phalen's sign",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"F[0].Page_4[0].P[0]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"F[0].Page_4[0].P[1]",
                  "sub":""
               }
            ],
            "answer":"Negative"
         },
         {
            "label":"Right Tinel's sign",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"F[0].Page_4[0].Tinels[1]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"F[0].Page_4[0].Tinels[0]",
                  "sub":""
               }
            ],
            "answer":"Negative"
         },
         {
            "label":"Left Tinel's sign",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"F[0].Page_4[0].T[1]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"F[0].Page_4[0].T[0]",
                  "sub":""
               }
            ],
            "answer":"Negative"
         }
      ]
   },

   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Radial nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      // "note":'Indicate the affected nerves, side affected and severity of condition',
      "section": {
         page: "5",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10A"
      },
      "questions":[
         {
            "main":"Radial nerve (musculospiral nerve)",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (hand and fingers drop, wrist and fingers flexed; cannot extend hand at wrist, extend proximal phalanges of fingers, extend thumb or make lateral movement of wrist; supination of hand, elbow extension and flexion weak, hand grip impaired)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].Normalr[0]",
                  "colWidth": "3",
                  "answer":"Normal"
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].Incompleteparalysis[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].Completeparalysis[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild1[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate2[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe3[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Radial nerve (musculospiral nerve)",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].NormalL[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].ICP1[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].CP1[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Median nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10B"
      },
      "questions":[
         {
            "main":"Median nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (hand inclined to the ulnar side, index and middle fingers extended, atrophy of thenar eminence, cannot make fist, defective opposition of thumb, cannot flex distal phalanx of thumb; wrist flexion weak)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].Normalr[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].Incompleteparalysis[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].Completeparalysis[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild1[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate2[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe3[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Median nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].NormalL[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].ICP1[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].CP1[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Ulnar nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10C"
      },
      "questions":[
         {
            "main":"Ulnar nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": 'Complete paralysis ("griffin claw" deformity, atrophy in dorsal interspaces, thenar and hypothenar eminences; cannot extend ring and little finger, cannot spread fingers, cannot adduct the thumb; wrist flexion weakened)',
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].Normalr[2]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].Incompleteparalysis[2]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].Completeparalysis[2]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild1[2]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate2[2]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe3[2]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Ulnar nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].NormalL[2]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].ICP1[2]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].CP1[2]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild[2]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate[2]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe[2]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Musculocutaneous nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10D"
      },
      "questions":[
         {
            "main":"Musculocutaneous nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (weakened flexion of elbow and supination of forearm)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].Normalr[3]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].Incompleteparalysis[3]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].Completeparalysis[3]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild1[3]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate2[3]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe3[3]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Musculocutaneous nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].NormalL[3]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].ICP1[3]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].CP1[3]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild[3]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate[3]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe[3]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Circumflex nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10E"
      },
      "questions":[
         {
            "main":"Circumflex nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (innervates deltoid and teres minor; cannot abduct arm, outward rotation is weakened)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].Normalr[4]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].Incompleteparalysis[4]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].Completeparalysis[4]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild1[4]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate2[4]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe3[4]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Circumflex nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].NormalL[4]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].ICP1[4]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].CP1[4]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild[4]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate[4]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe[4]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Long thoracic nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10F"
      },
      "questions":[
         {
            "main":"Long thoracic nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (inability to raise arm above shoulder level, winged scapula deformity)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].Normalr[5]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].Incompleteparalysis[5]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].Completeparalysis[5]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild1[5]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate2[5]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe3[5]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Long thoracic nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].NormalL[5]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_5[0].ICP1[5]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_5[0].CP1[5]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_5[0].Mild[5]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_5[0].Moderate[5]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_5[0].Severe[5]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Upper radicular group",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10G"
      },
      "questions":[
         {
            "main":"Upper radicular group",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (all shoulder and elbow movements lost; hand and wrist movements not affected)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].Normalr[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Incompleteparalysis[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Completeparalysis[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild1[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate2[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe3[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Upper radicular group",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].NormalL[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].ICP1[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].CP1[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Middle radicular group",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10H"
      },
      "questions":[
         {
            "main":"Middle radicular group",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": " Complete paralysis (adduction, abduction, rotation of arm, flexion of elbow and extension of wrist lost)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].Normalr[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Incompleteparalysis[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Completeparalysis[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild1[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate2[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe3[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Middle radicular group",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].NormalL[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].ICP1[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].CP1[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an upper extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Lower radicular group",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "NERVES AFFECTED: Upper Extremity",
         number: "10I"
      },
      "questions":[
         {
            "main":"Lower radicular group",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (intrinsic hand muscles, wrist and finger flexors paralyzed; substantial loss of use of hand)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].Normalr[2]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Incompleteparalysis[2]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Completeparalysis[2]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild1[2]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate2[2]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe3[2]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Lower radicular group",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].NormalL[2]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].ICP1[2]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].CP1[2]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild[2]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate[2]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe[2]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },


   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Sciatic nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11A"
      },
      "questions":[
         {
            "main":"Sciatic nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (foot dangles and drops, no active movement of muscles below the knee, flexion of knee weakened or lost)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].NotAffected43[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Complete21[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Complete21a[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].NotAffected41[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Mild21a[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Moderately Severe",
                  "dbqName":"F[0].Page_6[0].Moderate21[0]",
                  "colWidth": "6",
                  "answer":""
               },
               {
                  "main":"Severe, with marked muscular atrophy",
                  "dbqName":"F[0].Page_6[0].Severe21[0]",
                  "colWidth": "6",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Sciatic nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].NotAffected430[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Complete210a[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Complete210[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].NotAffected41q[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Mild21q[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Moderately Severe",
                  "dbqName":"F[0].Page_6[0].Moderate21qq[0]",
                  "colWidth": "6",
                  "answer":""
               },
               {
                  "main":"Severe, with marked muscular atrophy",
                  "dbqName":"F[0].Page_6[0].Severe21q[0]",
                  "colWidth": "6",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "External popliteal (common peroneal) nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11B"
      },
      "questions":[
         {
            "main":"External popliteal nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (foot drop, cannot dorsiflex foot or extend toes; dorsum of foot and toes are numb)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].Normalr10[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Incompleteparalysis10[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Completeparalysis10[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild2910[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate2910[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe3910[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"External popliteal nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].NormalL10[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].ICP10[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].CP10[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild10[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].ModerateL10[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe10[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Musculocutaneous (superficial peroneal) nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11C"
      },
      "questions":[
         {
            "main":"Musculocutaneous nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (eversion of foot weakened)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_6[0].Normalr11[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_6[0].Incompleteparalysis11[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_6[0].Completeparalysis11[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_6[0].Mild2911[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_6[0].Moderate2911[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_6[0].Severe3911[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Musculocutaneous nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr11[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis11[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis11[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2911[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2911[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3911[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Anterior tibial (deep peroneal) nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11D"
      },
      "questions":[
         {
            "main":"Anterior tibial nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (dorsiflexion of foot lost)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr12[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis12[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis12[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2912[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2912[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3912[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Anterior tibial nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].NormalL12[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].ICP12[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].CP12[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild12[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].ModerateL12[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe12[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Internal popliteal (tibial) nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11E"
      },
      "questions":[
         {
            "main":"Internal popliteal nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (plantar flexion lost, frank adduction of foot impossible, flexion and separation of toes abolished; no muscle in sole can move; in lesions of the nerve high in popliteal fossa, plantar flexion of foot is lost)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr12[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis12[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis12[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2912[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2912[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3912[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Internal popliteal nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].NormalL12[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].ICP12[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].CP12[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild12[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].ModerateL12[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe12[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Posterior tibial nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11F"
      },
      "questions":[
         {
            "main":"Posterior tibial nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": " Complete paralysis (paralysis of all muscles of sole of foot, frequently with painful paralysis of a causalgic nature; loss of toe flexion; adduction weakened; plantar flexion impaired)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr12[2]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis12[2]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis12[2]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2912[2]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2912[2]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3912[2]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Posterior tibial nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].NormalL12[2]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].ICP12[2]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].CP12[2]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild12[2]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].ModerateL12[2]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe12[2]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Anterior crural (femoral) nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11G"
      },
      "questions":[
         {
            "main":"Anterior crural nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "note": "Complete paralysis (paralysis of quadriceps extensor muscles)",
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr12[3]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis12[3]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis12[3]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2912[3]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2912[3]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3912[3]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Anterior crural nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].NormalL12[3]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].ICP12[3]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].CP12[3]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild12[3]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].ModerateL12[3]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe12[3]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Internal saphenous nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11H"
      },
      "questions":[
         {
            "main":"Internal saphenous nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr12[4]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis12[4]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis12[4]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2912[4]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2912[4]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3912[4]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Internal saphenous nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].NormalL12[4]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].ICP12[4]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].CP12[4]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild12[4]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].ModerateL12[4]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe12[4]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Obturator nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11I"
      },
      "questions":[
         {
            "main":"Obturator nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].Normalr12[5]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].Incompleteparalysis12[5]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].Completeparalysis12[5]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild2912[5]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].Moderate2912[5]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe3912[5]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Obturator nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_7[0].NormalL12[5]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_7[0].ICP12[5]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_7[0].CP12[5]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_7[0].Mild12[5]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_7[0].ModerateL12[5]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_7[0].Severe12[5]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "External cutaneous nerve of the thigh",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11J"
      },
      "questions":[
         {
            "main":"External cutaneous nerve of the thigh",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_8[0].Normalr18[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_8[0].Incompleteparalysis18[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_8[0].Completeparalysis18[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_8[0].Mild2918[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_8[0].Moderate2918[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_8[0].Severe3918[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"External cutaneous nerve of the thigh",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_8[0].NormalL18[0]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_8[0].ICP18[0]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_8[0].CP18[0]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_8[0].Mild18[0]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_8[0].ModerateL18[0]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_8[0].Severe18[0]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   {
      "question":"Does ##name## have an lower extremity ##redHeading## diabetic peripheral neuropathy?",
      "redHeading": "Illio-inguinal nerve",
      "sub":"Indicate the affected nerves, side affected and severity of condition",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "NERVES AFFECTED: Lower Extremity",
         number: "11K"
      },
      "questions":[
         {
            "main":"Illio-inguinal nerve",
            "dbqName":"pass_this_question",
            "heading" : "Right",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_8[0].Normalr18[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_8[0].Incompleteparalysis18[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_8[0].Completeparalysis18[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_8[0].Mild2918[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_8[0].Moderate2918[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_8[0].Severe3918[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },
         {
            "main":"Illio-inguinal nerve",
            "dbqName":"pass_this_question",
            "heading" : "Left",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_8[0].NormalL18[1]",
                  "colWidth": "3",
                  "answer":""
               },
               {
                  "main":"Incomplete paralysis",
                  "dbqName":"F[0].Page_8[0].ICP18[1]",
                  "colWidth": "5",
                  "subItem3Linked": true,
                  "answer":""
               },
               {
                  "main":"Complete paralysis",
                  "dbqName":"F[0].Page_8[0].CP18[1]",
                  "answer":""
               },                     
            ],
            "subAnswer":"",
            "subItemsLabel" :"Indicate severity",
            "showSubItems3": false,
            "subItems3": [
               {
                  "main":"Mild",
                  "dbqName":"F[0].Page_8[0].Mild18[1]",
                  "answer":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"F[0].Page_8[0].ModerateL18[1]",
                  "answer":""
               },
               {
                  "main":"Severe",
                  "dbqName":"F[0].Page_8[0].Severe18[1]",
                  "answer":""
               }
            ],
            "subAnswer3":"",
            "subItems3Label" :"Indicate severity",
         },              
      ]
   },
   

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":90,
      "show": true,
      "section": {
         page: "9",
         title: "REMARKS",
         number: "17"
      },
      "dbqName":"F[0].Page_10[0].Remarks[0]",
      "answer":""
   }
 ]

 export default nerves_questions ;
